export const SNIPPET_BLOCK_CONSTANTS = {
	DEFAULT_MAX_LINES: 3,
	MAXIMUM_MAX_LINES: 6,
	MINIMUM_MAX_LINES: 1,
} as const;
